import React from 'react';
import styled from 'styled-components';
import Check from '@mui/icons-material/Check';
import FlexboxContainer from 'components/UI/FlexboxContainer';
import { BADGE_COLORS } from 'constants/productBadges';
import { Main, Text } from 'styles/themeColors';
import { BorderRadius } from 'styles/themeBorderRadius';
import { FontSize, FontWeight } from 'lib/styles';

const Swatch = styled.button<{ $bgColor: string; $selected: boolean }>`
  height: 40px;
  min-width: 70px;
  padding: ${({ $selected }) => ($selected ? '0 12px' : '0')};
  border-radius: ${BorderRadius.s};
  background-color: ${({ $bgColor, $selected }) => ($selected ? Main.white : $bgColor)};
  border: 2px solid ${({ $bgColor, $selected }) => ($selected ? $bgColor : 'transparent')};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
`;

const SwatchLabel = styled.span`
  margin-top: 4px;
  font-size: ${FontSize.smaller};
  line-height: 16px;
  color: ${Text.secondary};
`;

const SelectedLabel = styled.span<{ $color: string }>`
  font-size: ${FontSize.small};
  font-weight: ${FontWeight.bold};
  color: ${({ $color }) => $color};
  white-space: nowrap;
`;

interface Props {
  value: string;
  onChange: (colorHash: string) => void;
  disabled?: boolean;
}

const BadgeColorPicker = ({ value, onChange, disabled }: Props) => (
  <FlexboxContainer flexDirection="row" gap="12px" alignItems="flex-start" width="auto">
    {BADGE_COLORS.map(color => (
      <FlexboxContainer
        key={color.hex}
        flexDirection="column"
        alignItems="center"
        width="auto"
      >
        <Swatch
          type="button"
          aria-label={color.label}
          aria-pressed={value === color.hex}
          disabled={disabled}
          $bgColor={color.hex}
          $selected={value === color.hex}
          onClick={() => onChange(color.hex)}
        >
          {value === color.hex ? (
            <>
              <Check style={{ color: color.hex, fontSize: '18px' }} />
              <SelectedLabel $color={color.hex}>{color.label}</SelectedLabel>
            </>
          ) : null}
        </Swatch>
        {value !== color.hex ? <SwatchLabel>{color.label}</SwatchLabel> : null}
      </FlexboxContainer>
    ))}
  </FlexboxContainer>
);

export default BadgeColorPicker;